/// <amd-module name="SuiteCommerce.GridOrder.Row.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Row.View", ["require", "exports", "Backbone", "Backbone.CollectionView", "SuiteCommerce.GridOrder.Cell.View", "grid_order_row.tpl"], function (require, exports, Backbone_1, BackboneCollectionView, GridOrder_Cell_View_1, rowTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RowView = /** @class */ (function (_super) {
        __extends(RowView, _super);
        function RowView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = rowTemplate;
            _this.container = options.container;
            return _this;
        }
        Object.defineProperty(RowView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'Cell.Collection': function () {
                        return new BackboneCollectionView({
                            childView: GridOrder_Cell_View_1.CellView,
                            collection: _this.model.cellsCollection,
                            childViewOptions: {
                                container: _this.container,
                            },
                        });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        RowView.prototype.getContext = function () {
            return {
                hasPricesSchedules: this.model.hasPricesSchedules(),
            };
        };
        return RowView;
    }(Backbone_1.View));
    exports.RowView = RowView;
});
